import { render, staticRenderFns } from "./zlg.vue?vue&type=template&id=0880c996&scoped=true"
import script from "./zlg.vue?vue&type=script&lang=js"
export * from "./zlg.vue?vue&type=script&lang=js"
import style0 from "./zlg.vue?vue&type=style&index=0&id=0880c996&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0880c996",
  null
  
)

export default component.exports